var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('bsh-datatable',{attrs:{"columns":_vm.columns,"buttons":_vm.buttons,"link":_vm.link,"actionFild":"","sorting":""},on:{"selectRow":_vm.visualizar,"visualizar":_vm.visualizar}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }